import cover1920It from '../../assets/ceramol-acne-non-e-un-problema-1920.jpg'
import cover1280It from '../../assets/ceramol-acne-non-e-un-problema-1280.jpg'
import cover1024It from '../../assets/ceramol-acne-non-e-un-problema-1024.jpg'
import cover768It from '../../assets/ceramol-acne-non-e-un-problema-768.jpg'
// import cover1920Fr from '../../assets/ceramol-acne-ne-sera-plus-un-probleme-1920.jpg'
// import cover1280Fr from '../../assets/ceramol-acne-ne-sera-plus-un-probleme-1280.jpg'
// import cover1024Fr from '../../assets/ceramol-acne-ne-sera-plus-un-probleme-1024.jpg'
// import cover768Fr from '../../assets/ceramol-acne-ne-sera-plus-un-probleme-768.jpg'
import './Cover.css'
import {
  /* Language, useLanguage, */ useTranslate
} from '../../TranslationsContext'

function getCoverStyle(/*currentLanguage: keyof typeof Language*/): string {
  return `
        .Cover {
          background-image: url('${cover768It}');
        }

        @media all and (min-width: 768px) {
          .Cover {
            background-image: url('${cover1024It}');
          }
        }

        @media all and (min-width: 1024px) {
          .Cover {
            background-image: url('${cover1280It}');
          }
        }

        @media all and (min-width: 1280px) {
          .Cover {
            background-image: url('${cover1920It}');
          }
        }
      `

  // switch (currentLanguage) {
  //   case 'it':
  //   case 'es':
  //   case 'de':
  //     return `
  //       .Cover {
  //         background-image: url('${cover768It}');
  //       }

  //       @media all and (min-width: 768px) {
  //         .Cover {
  //           background-image: url('${cover1024It}');
  //         }
  //       }

  //       @media all and (min-width: 1024px) {
  //         .Cover {
  //           background-image: url('${cover1280It}');
  //         }
  //       }

  //       @media all and (min-width: 1280px) {
  //         .Cover {
  //           background-image: url('${cover1920It}');
  //         }
  //       }
  //     `
  //   case 'fr':
  //     return `
  //       .Cover {
  //         background-image: url('${cover768Fr}');
  //       }

  //       @media all and (min-width: 1024px) {
  //         .Cover {
  //           background-image: url('${cover1024Fr}');
  //         }
  //       }

  //       @media all and (min-width: 1280px) {
  //         .Cover {
  //           background-image: url('${cover1280Fr}');
  //         }
  //       }

  //       @media all and (min-width: 1920px) {
  //         .Cover {
  //           background-image: url('${cover1920Fr}');
  //         }
  //       }
  //     `
  // }
}

export function Cover() {
  const translate = useTranslate()
  // const currentLanguage = useLanguage()
  const claimFourthRow = translate('Cover.claim.4')

  return (
    <>
      <div className="Cover">
        <h1>
          <mark>
            &nbsp;{translate('Cover.claim.1')}&nbsp;
            <br />
            &nbsp;{translate('Cover.claim.2')}&nbsp;
            <br />
            &nbsp;{translate('Cover.claim.3')}&nbsp;
            <br />
            {claimFourthRow === 'Cover.claim.4' ? null : (
              <>
                &nbsp;{translate('Cover.claim.4')}&nbsp;
                <br />
              </>
            )}
          </mark>
        </h1>
      </div>
      <style scoped>{getCoverStyle(/*currentLanguage*/)}</style>
    </>
  )
}
